import React, { useRef, useEffect, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { useMsal } from '@azure/msal-react';
import BackButton from '../components/BackButton';

export default function PowerBi({ showBackButton, name }) {
  // Keep a ref to the embedded instance if you need to call APIs later
  const embedRef = useRef(null);

  const { instance, accounts } = useMsal();
  const activeAccount = accounts && accounts.length > 0 ? accounts[0] : null;
  const [aadToken, setAadToken] = useState(null);
  const [tokenError, setTokenError] = useState(null);
  let id;
  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (!instance || !activeAccount) return;
      try {
        // Power BI resource scope for AAD tokens
        const scopes = ['https://analysis.windows.net/powerbi/api/.default'];
        const result = await instance.acquireTokenSilent({ scopes, account: activeAccount });
        if (!cancelled) {
          setAadToken(result.accessToken);
          setTokenError(null);
        }
      } catch (e) {
        console.error('Power BI token acquisition failed', e);
        if (!cancelled) setTokenError(e?.message || 'Token acquisition failed');
      }
    };
    run();
    return () => { cancelled = true; };
  }, [instance, activeAccount]);

  if (!aadToken && !tokenError) {
    return <div style={{ padding: 16 }}>Loading Power BI…</div>;
  }
  if (name === "incident") {
    id = "18fdb0f1-6fa6-4229-9bb3-6c485edb0eec"
  }
  else if (name === "finops") {
    id = "0d6888ea-c618-4f23-9375-0a4eb1894a98"
  }
  else if (name === "greenops") {
    id = "5af8f510-c3be-4517-925f-ed3d1b42b267"
  }
  else if (name === "tdp-asset"){
    id="5822e88b-47a7-47bb-b580-175d486cb294"
  }
  
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      {showBackButton && <BackButton />}
      <div style={{ flex: 1 }}>
      <PowerBIEmbed
        embedConfig={{
          type: 'report', // report | dashboard | tile | visual | qna | paginated report | create
          id: id,
          // For My workspace you can omit groupId; if you move this report to a workspace, add &groupId=<workspaceId>
          embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${id}`,
          accessToken: aadToken || '',
          tokenType: models.TokenType.Aad,
          settings: {
            panes: {
              filters: { expanded: false, visible: false },
            },
            background: models.BackgroundType.Transparent,
          },
        }}
        eventHandlers={
          new Map([
            ['loaded', () => console.log('Report loaded')],
            ['rendered', () => console.log('Report rendered')],
            ['error', (event) => console.log(event?.detail)],
            ['visualClicked', () => console.log('visual clicked')],
            ['pageChanged', (event) => console.log(event)],
          ])
        }
        cssClassName={"reportClass"}
        getEmbeddedComponent={(embedded) => {
          embedRef.current = embedded;
        }}
      />
    </div>
  </div >
  );
}


